import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ActividadPasosPlanPayload {
  id_paso: number;
  id_plan: number;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface ActividadPasosPlan {
  ActividadPasosPlanreData: never[];
  PasoActividadPlanData: any;
  id?: number;
  id_plan: number;
  id_paso: number;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface ActividadPasosPlanResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ActividadPasosPlanService {
  private readonly apiUrl = `${environment.apiUrl}/api/actividad_pasos_plan`;

  constructor(private http: HttpClient) {}

  // Listar todas las actividades de pasos
  getAll(): Observable<ActividadPasosPlan[]> {
    return this.http.get<ActividadPasosPlan[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<ActividadPasosPlan> {
    return this.http.get<ActividadPasosPlan>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  getByIdPlan(id_plan: number): Observable<ActividadPasosPlan[]> {
      return this.http.get<ActividadPasosPlan[]>(`${this.apiUrl}/plan/${id_plan}`, { withCredentials: true });
    }

  // Crear nueva actividad de paso
  create(payload: ActividadPasosPlanPayload): Observable<ActividadPasosPlanResponse> {
    return this.http.post<ActividadPasosPlanResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar actividad de paso
  update(id: number, payload: Partial<ActividadPasosPlanPayload>): Observable<ActividadPasosPlanResponse> {
    return this.http.put<ActividadPasosPlanResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar actividad de paso (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar actividad de paso
  inactivar(id: number): Observable<ActividadPasosPlanResponse> {
    return this.http.put<ActividadPasosPlanResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar actividad de paso
  activar(id: number): Observable<ActividadPasosPlanResponse> {
    return this.http.put<ActividadPasosPlanResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}